import { render, staticRenderFns } from "./referrals.datatable.vue?vue&type=template&id=7e8d3629&scoped=true&"
import script from "./referrals.datatable.vue?vue&type=script&lang=js&"
export * from "./referrals.datatable.vue?vue&type=script&lang=js&"
import style0 from "./referrals.datatable.vue?vue&type=style&index=0&id=7e8d3629&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8d3629",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
